import { useContext } from 'react';

import { TranslationsContext } from '../contexts/translations-context';

export const useLocale = () => {
   const translationsContext = useContext(TranslationsContext);
   return translationsContext.locale;
};
